import React, { useState } from 'react';

import Link from 'next/link';
import { HiChevronDown } from 'react-icons/hi';
import { useWindowSize } from 'usehooks-ts';

import Layout from '@/modules/core/components/Layout';
import { FirstSectionContent } from '@/modules/core/components/Services/FirstSectionContent';
import { FourthSectionContent } from '@/modules/core/components/Services/FourthSectionContent';
import { SecondSectionContent } from '@/modules/core/components/Services/SecondSectionContent';
import { ThirdSectionContent } from '@/modules/core/components/Services/ThirdSectionContent';
import Text from '@/tayara-kit/Text';

const SectionCards = ({
  activeAction,
  cardContents,
  handleActionClick,
}: any) => (
  <>
    <div className="block xl:hidden absolute right-0 px-8 md:px-10 h-full bg-gradient-to-l from-neutral-50 z-[9999]"></div>
    <div className="relative block overflow-x-auto xl:overflow-hidden overflow-y-hidden xl:flex pb-8">
      <div className="inline-block min-w-full align-middle  lg:px-0 ">
        <div className="my-2 py-2 flex justify-center items-center gap-3 md:gap-4">
          {cardContents.map((cardContent: any) => (
            <div
              key={''}
              className={
                activeAction === cardContent.title
                  ? `${cardContent.cardClassName} ${cardContent.cardOutline}`
                  : cardContent.cardClassName
              }
            >
              <Text
                text={cardContent.title}
                as="h3"
                className="text-lg xl:text-xl 2xl:text-2xl text-center font-extrabold text-neutral-800 flex-1 mt-6 mx-4"
              />
              <Text
                text={cardContent.text}
                as="p"
                className="text-xs lg:text-sm xl:text-sm text-center flex-1 my-2 lg:my-6 mx-2"
              />
              <button
                className={
                  activeAction === cardContent.title
                    ? `${cardContent.buttonClassName} ${cardContent.cardOutline}`
                    : cardContent.buttonClassName
                }
                onClick={() => handleActionClick(cardContent.action)}
              >
                {cardContent.actionTitle}
              </button>
              <Link
                href={'/contact'}
                target="_blank"
                replace
                passHref
                className=""
              >
                <button className="w-full mb-2 underline text-2xs lg:text-xs truncate text-neutral-800 font-normal">
                  {cardContent.secondActionTiltle}
                </button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  </>
);

const ServicesPage = () => {
  const [activeAction, setActiveAction] = useState(null || '');
  const cardContents = [
    {
      title: 'Commencez gratuitement',
      text: 'Trouvez les produits que vous cherchez ou créez gratuitement un profil pour partager vos annonces',
      action: () => setActiveAction('Commencez gratuitement'),
      actionTitle: 'Découvrir le plan basique',
      buttonClassName:
        'w-fit py-2 px-4 mb-4 text-2xs lg:text-sm  font-semibold truncate rounded-xl !border-[1px] !border-neutral-300 text-neutral-600 active:outline active:outline-1 active:outline-offset-2 active:outline-neutral-300 hover:bg-neutral-100',
      seconAction: '',
      secondActionTiltle: '',
      cardClassName:
        'flex flex-col justify-center items-center w-[12rem] h-[20rem]  lg:w-[20rem] lg:h-[24rem] p-4 rounded-2xl border-[1px]  border-neutral-300 bg-white/80 border-t-8 bg-gradient-to-t from-stone-200/30  hover:from-white hover:to-white lg:hover:-translate-y-1 xl:hover:shadow-md xl:transform-gpu',
      cardOutline:
        'outline outline-2 outline-offset-4 outline-neutral-300 !bg-gradient-to-b !from-white !shadow-none !translate-y-0 ',
    },
    {
      title: 'Achetez des Jetons facilement',
      text: 'Achetez des Jetons et profitez de nos services et produits à valeur ajoutée',
      action: () => setActiveAction('Achetez des Jetons facilement'),
      actionTitle: 'Voir les forfaits de Jetons',
      buttonClassName:
        'w-fit py-2 px-4 mb-4 text-2xs lg:text-sm  font-semibold truncate rounded-xl !border-[1px] !border-neutral-300 text-info active:outline active:outline-1 active:outline-offset-2 active:outline-info hover:bg-neutral-100',
      seconAction: '',
      secondActionTiltle: 'Contactez-nous',
      cardClassName:
        'flex flex-col justify-center items-center w-[12rem] h-[20rem]  lg:w-[20rem] lg:h-[24rem] p-4 rounded-2xl border-[1px]  border-neutral-300 border-t-info bg-white/80 border-t-8 bg-gradient-to-t from-stone-200/30  hover:from-white hover:to-white lg:hover:-translate-y-1 xl:hover:shadow-md xl:transform-gpu',
      cardOutline:
        'outline outline-2 outline-offset-4 outline-info/60 !bg-gradient-to-b !from-white !shadow-none !translate-y-0 ',
    },
    {
      title: 'Boostez vos annonces efficacement',
      text: 'Renforcez la visibilité de vos annonces et vendez plus vite avec nos différents boosts',
      action: () => setActiveAction('Boostez vos annonces efficacement'),
      actionTitle: 'En savoir plus sur les boosts',
      buttonClassName:
        'w-fit py-2 px-4 mb-4 text-2xs lg:text-sm  font-semibold truncate rounded-xl !border-[1px] !border-neutral-300 text-neutral-600 text-orange-600 active:outline active:outline-1 active:outline-offset-2 active:outline-orange-400 hover:bg-neutral-100',
      seconAction: '',
      secondActionTiltle: 'Contactez-nous',
      cardClassName:
        'flex flex-col justify-center items-center w-[12rem] h-[20rem]  lg:w-[20rem] lg:h-[24rem] p-4 rounded-2xl border-[1px]  border-neutral-300 border-t-orange-400 bg-white/80 border-t-8 bg-gradient-to-t from-stone-200/30  hover:from-white hover:to-white lg:hover:-translate-y-1 xl:hover:shadow-md xl:transform-gpu',
      cardOutline:
        'outline outline-2 outline-offset-4 outline-orange-300 !bg-gradient-to-b !from-white !shadow-none !translate-y-0 ',
    },
    {
      title: 'Choisissez votre offre',
      text: 'Comparez les avantages de nos offres Pro',
      action: () => setActiveAction('Choisissez votre offre'),
      actionTitle: 'Comparer les offres',
      buttonClassName:
        'w-fit py-2 px-4 mb-4 text-2xs lg:text-sm  font-semibold truncate rounded-xl !border-[1px] !border-neutral-300 text-neutral-600 text-primary active:outline active:outline-1 active:outline-offset-2 active:outline-primary hover:bg-neutral-100',
      seconAction: '',
      secondActionTiltle: 'Contactez-nous',
      cardClassName:
        'flex flex-col justify-center items-center w-[12rem] h-[20rem]  lg:w-[20rem] lg:h-[24rem] p-4 rounded-2xl border-[1px]  border-neutral-300 border-t-primary bg-white/80 border-t-8 bg-gradient-to-t from-stone-200/30  hover:from-white hover:to-white lg:hover:-translate-y-1 xl:hover:shadow-md xl:transform-gpu',
      cardOutline:
        'outline outline-2 outline-offset-4 outline-primary !bg-gradient-to-b !from-white !shadow-none !translate-y-0 ',
    },
  ];

  function scrollToMiddle() {
    const totalHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );

    let middle;

    // Check the screen width and adjust the middle value accordingly
    if (window.innerWidth <= 768) {
      // You can adjust the screen width threshold as needed
      middle = totalHeight / 9; // For small devices
    } else {
      middle = totalHeight / 6; // For larger devices
    }

    window.scrollTo({
      top: middle,
      behavior: 'smooth', // You can use 'auto' or 'smooth' for scrolling behavior
    });
  }

  const handleActionClick = (actionFunction: any) => {
    actionFunction();
    scrollToMiddle();
  };
  const windowSize = useWindowSize();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <div className=" justify-center items-center">
        <img
          src="/media/OffersAndServicesBackground.png"
          alt="Services tayara's background page"
          className="absolute top-0 left-0 w-full h-fit -z-50 "
        />
        <div className="flex flex-col justify-center items-center my-4 lg:my-0 mx-4 lg:mx-[15vw]">
          <Text
            text="Savez-vous ce qu'il vous faut?"
            as="h3"
            className="font-light text-sm lg:text-base xl:text-lg text-center text-neutral-700 mt-2"
          />
          <Text
            text="Offres et Services"
            as="h2"
            className="truncate font-extrabold text-4xl lg:text-5xl text-center text-primary"
          />
          <Text
            text="Découvrez les offres et services conçues pour répondre à vos besoins"
            as="h3"
            className="font-medium text-sm lg:text-base xl:text-lg text-center text-neutral-700"
          />
          <div className="flex flex-col">
            <p
              className={`text-sm lg:text-lg text-center font-light text-neutral-700 mt-7  ${
                !isExpanded && windowSize.width < 1200
                  ? 'whitespace-pre-line line-clamp-2'
                  : ''
              }`}
            >
              Tayara vous offre la flexibilité de démarrer gratuitement et de
              profiter de nos produits et services à valeur ajoutée.
              <br />
              Que vous soyez un utilisateur passager, un commmerçant ou un
              professionnel indépendant, nous mettons à votre disposition une
              panoplie de solutions pour vous aider à optimiser vos annonces,
              augmenter votre visibilité et atteindre vos objectifs.
            </p>

            {/* Show more button */}
            {windowSize.width < 1200 && (
              <button
                className="text-xs flex justify-center items-center gap-x-1 text-primary font-medium mt-2"
                onClick={() => toggleExpanded()}
              >
                <Text
                  as="span"
                  text={`${!isExpanded ? 'Lire plus' : 'Moins'}`}
                  className="truncate"
                />
                <HiChevronDown
                  size={18}
                  className={`${isExpanded ? 'rotate-180' : ''}`}
                />
              </button>
            )}
          </div>
        </div>
        <p className="font-semibold text-xl lg:text-2xl xl:text-3xl text-center text-neutral-700 my-4 lg:my-12 lg:mx-8">
          Bénéficiez de{' '}
          <span
            className="bg-no-repeat bg-contain bg-bottom py-[5px]"
            style={{
              backgroundImage: `url(/media/underline.png)`,
            }}
          >
            tayara gratuitement
          </span>
          , boostez votre visibilité et vendez rapidement avec nos offres
          adaptées!
        </p>
        <div
          className="w-full h-full bg-no-repeat bg-cover bg-local bg-[center_top_5rem] grayscale-0 p-4 md:p-0"
          style={{
            backgroundImage: `url(/media/BoostSectionBackground.png)`,
          }}
        >
          <SectionCards
            activeAction={activeAction}
            handleActionClick={handleActionClick}
            cardContents={cardContents}
          />
          {/* Render the corresponding content based on the active action */}
          {activeAction === 'Commencez gratuitement' && <FirstSectionContent />}
          {activeAction === 'Achetez des Jetons facilement' && (
            <SecondSectionContent />
          )}
          {activeAction === 'Boostez vos annonces efficacement' && (
            <ThirdSectionContent />
          )}
          {activeAction === 'Choisissez votre offre' && (
            <FourthSectionContent
              handleActionClick={setActiveAction}
              activeAction={activeAction}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default ServicesPage;

// Dynamic layout configuration
ServicesPage.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
